var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5879 2.18909C19.3561 1.33636 18.6864 0.661818 17.8236 0.432727C16.2653 0 9.99356 0 9.99356 0C9.99356 0 3.73471 0 2.17643 0.407273C1.33934 0.636364 0.643915 1.33636 0.412106 2.18909C0 3.75455 0 7 0 7C0 7 0 10.2582 0.412106 11.8109C0.643915 12.6636 1.31359 13.3382 2.17643 13.5673C3.76046 14 9.99356 14 9.99356 14C9.99356 14 16.2653 14 17.8236 13.5927C18.6864 13.3636 19.3561 12.6764 19.5879 11.8236C20 10.2582 20 7.01273 20 7.01273C20 7.01273 20 3.75455 19.5879 2.18909ZM8.0103 10.0036V3.99636L13.2131 7L8.0103 10.0036Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/YT.88e8fc5a46a807b68bdb8daf2588fddb.svg";
export { ForwardRef as ReactComponent };